import * as React from "react";
import { PropsWithChildren } from "react";
import { useState } from "react";

import { NavBarContextProvider } from "./NavBarContext";
import { ToggleSource } from "./NavBarContext";

export const NavBarProvider = ({ children }: PropsWithChildren<{}>) => {
  const [expanded, setExpanded] = useState(true);
  const [hasUserManuallyToggled, setHasUserManuallyToggled] = useState(false);

  const toggleExpanded = (source: ToggleSource, isOpened?: boolean) => {
    const newExpanded = isOpened ?? !expanded;

    if (source === ToggleSource.UserInteraction) {
      setHasUserManuallyToggled(true);
      setExpanded(newExpanded);
      return;
    }

    if (source === ToggleSource.RouteHandler && hasUserManuallyToggled) {
      // only allow automated toggles if the user has not already opted to
      // manually keep the menu open or closed.
      return;
    }

    setExpanded(newExpanded);
  };

  return (
    <NavBarContextProvider
      value={{ expanded, hasUserManuallyToggled, toggleExpanded }}
    >
      {children}
    </NavBarContextProvider>
  );
};
